import React from "react";

import { Loader } from "@components/ClinicalNewReportDialog/Loader";

export const ReportFallback: React.FC<
  React.PropsWithChildren<{
    title?: React.ReactNode;
    description?: React.ReactNode;
  }>
> = ({ children, title = "Loading Report", description = "Please wait..." }) => {
  return (
    <div className="mt-10 flex flex-col items-center gap-3 text-center">
      <Loader className="ml-0 mr-0 h-8 w-8 text-limestone-400" />
      <p className="text-base font-semibold text-limestone-900">{title}</p>
      <p className="text-sm text-limestone-500">{description}</p>
      {children}
    </div>
  );
};
